<template>
  <div>
    <div class="card">
      <div class="card-header">
        <center>
          <h3>
            Reporte de órdenes médicas
            <i class="fa fa-folder"></i>
          </h3>
        </center>
        <hr />
      </div>
      <div class="card-content">
        <div class="row">
          <div class="col-md-3">
            <label>Fecha inicial:</label>
            <input type="date" v-model="fecha_inicial" class="form-control" />
          </div>
          <div class="col-md-3">
            <label>Fecha final:</label>
            <input type="date" v-model="fecha_final" class="form-control" />
          </div>

          <div class="col-md-3" v-if="rol == 1">
              <label for="">Sede:</label>
              <select class="form-control" v-model="sede">
                <option

                  v-for="sede in SedesProgramacion"
                  :key="sede.sede"
                  :value="sede.sede"
                >
                  {{ sede.sede }}
                </option>
              </select>
              
            </div>

          <div class="col-md-3">
            <label for style="color:white;">d</label>
            <br />
            <button @click="getAutorizaciones()" class="btn btn-success btn-fill" style="border-radius:5px;">
              <i class="fa fa-search"></i> Buscar
            </button>
          </div>
           <div class="col-md-2">
                <!-- <button class="btn btn-success btn-sm">
                  <i color="black" class="fa fa-download"></i> Exportar
                </button> -->
                <label for style="color:white;">d</label> <br>
                <download-excel 
                  class="btn btn-primary btn-fill"
                  style="border-radius:5px;"
                  :data="json_data"
                  :fields="json_fields"
                  worksheet="My Worksheet"
                  :name="'Reporte-ordenes'+'-'+fecha_inicial+'-'+fecha_final"
                  v-if="json_data!=''"
                >
                Exportar a excel
                </download-excel>
              </div>
        </div>
        <br />
        <br />

        <!-- <div class="tabla"> -->
        <el-table class="table-striped" :data="autorizaciones" border>
          <el-table-column
            v-for="column in tableColumns"
            :key="column.label"
            :min-width="column.minWidth"
            :prop="column.prop"
            :label="column.label"
            else
          ></el-table-column>
        </el-table>
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    fecha_inicial: "",
    fecha_final: "",
    ip: "https://avanti-erp.com/api/",
    autorizaciones: [],
    fechaActual: "",
    rol: localStorage.getItem('rol'),
    sede: 'Sede Principal',
    SedesProgramacion: [],

    // tabla

    tableColumns: [
      {
        prop: "codigo", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Codigo", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 150, //ANCHO DE LA COLUMNA
      },
      {
        prop: "paciente", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Paciente", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 160, //ANCHO DE LA COLUMNA
      },

      {
        prop: "entidad",
        label: "Entidad",
        // minWidth: 150,
      },

      {
        prop: "bolsa",
        label: "Saldo en bolsa",
        minWidth: 100,
      },
      {
        prop: "vencimiento",
        label: "Vencimiento",
        minWidth: 130,
      },
      {
        prop: "orden",
        label: "Orden medica",
        minWidth: 150,
      },
      {
        prop: "ordenVencimiento",
        label: "Vencimiento de la orden",
        minWidth: 150,
      },
    ],

    json_fields: {
      "Nombres del paciente": "paciente",
      // "Apellidos del paciente" : "apellidos_paciente",
      "autorizacion" : "codigo",
      "Entidad" : 'entidad',
      "saldo en bolsa" : "bolsa",
      "Fecha vencimiento": "vencimientoExcel",
      "orden": "orden", 
      "vencimiento orden" : "ordenVencimientoExcel",
    },
    json_data: [],
    json_meta: [
      [
        {
          key: "charset",
          value: "utf-8",
        },
      ],
    ],
  }),
  methods: {
    getAutorizaciones() {
      if(this.fecha_inicial == '' || this.fecha_final == ''){
        alert('ERROR: Faltan fechas por seleccionar');
        return;
      }
      this.autorizaciones = [];
      this.$modal.show('carga');
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const sede = this.rol == 1 ? this.sede : localStorage.getItem('sede');
      const BASE_URL = `${this.ip}autorizacionesVencimiento/fechainicial=${this.fecha_inicial}/fechafinal=${this.fecha_final}/sede=${sede}`;
      axios.get(BASE_URL, config).then((res) => {
        // console.log(res.data);
        var datos = res.data.data;
        let autorizaciones = [];
        datos.forEach((element) => {
          let orden_medica = "";
          if (element.OrdPer != 1) {
            orden_medica = element.OrdPer;
          } else {
            orden_medica = "Autorización sin orden";
          }
          autorizaciones.push({
            codigo: element.OrdCod,
            paciente: element.PacApe1 + ' ' +  element.PacNom1,
            bolsa: element.OrdBol,
            entidad: element.EpsNom,
            vencimiento: element.OrdVen,
            vencimientoExcel: element.OrdVen,
            orden: orden_medica,
            ordenVencimiento: element.OrdMedVen,
            ordenVencimientoExcel : element.OrdMedVen
          });
        });
        this.autorizaciones = autorizaciones;
        this.json_data  = autorizaciones;
        this.$modal.hide('carga');
        // console.log(autorizaciones);
      }).catch(err =>{
        console.log(err);
        this.$modal.hide('carga');
      });
    },

    calcularVencimiento(fecha) {
      // return fecha;

      if (fecha == "Sin orden") {
        return "Autorización sin orden";
      } else {
        var fechaini = new Date(this.fechaActual);
        var fechafin = new Date(fecha);
        var diasdif = fechafin.getTime() - fechaini.getTime();
        var contdias = Math.round(diasdif / (1000 * 60 * 60 * 24));
        // alert(contdias);
        // return fecha;

        if (contdias == 0) {
          return "Vence hoy";
        } else if (contdias < 0) {
          return "Vencida";
        } else {
          return "Fatan " + contdias + " dia(s) para su vencimiento";
        }
      }

      // var fecha_formated = new Date(fecha)
      // console.log( fecha_formated, 'Fecha formateada' );
    },

    calcularFechaActual() {
      var mes;
      var fecha_hoy = new Date();

      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = fecha_hoy.getMonth() + 1;
      var ahora_dia = fecha_hoy.getDate();

      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }

        this.fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        this.fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }
    },

    emailsProgramacion: function () {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const BASE_URL = `${this.ip}emailsProgramacion`;
      axios
        .get(BASE_URL, config)
        .then((res) => {
          let data = res.data.data;
          this.SedesProgramacion = data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.calcularFechaActual();
    this.emailsProgramacion();
  },
};
</script>
<style >
.btn, .btn-success {
  border-radius:5px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Reportes/Ordenes.vue